if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        let items = []
        
        // Get main product details
        const formData = new FormData(this.form);
        const mainProductId = formData.get('id');
        const mainQuantity = parseInt(formData.get('quantity') || 1);

        // Check if this is bundler button
        this.compProductsAtcBtn = this.querySelector('[type="submit"].card-bundler-atc-button');
        const isBundlerButton = !!this.compProductsAtcBtn;

        this.freebieProductId = this.submitButton.dataset.freebieProductId;
        if(this.freebieProductId){
          items = [
            { 
              id: this.freebieProductId,
              quantity: 1
            }
          ];
        }

        this.stairsProductId = this.submitButton.dataset.stairsProductId;
        if(this.stairsProductId){
          items = [
            { 
              id: this.stairsProductId,
              quantity: 1, 
              properties: {
                _isBundled: true,
              }, 
            }
          ];
        }

        // Handle Installation Product for regular ATC (non-bundle)
        this.installationProductId = this.submitButton.dataset.installationProductId;
        
        // Check for existing products BEFORE adding
        if(this.installationProductId && !isBundlerButton){
          const hasExisting = await this.checkAndUpdateExistingProduct(mainProductId, mainQuantity);
          if(hasExisting) return; // Exit early if we handled existing product
          
          items.push({ 
            id: this.installationProductId,
            quantity: mainQuantity,
            properties: {
              _installation_for: mainProductId,
              _is_installation: 'true'
            }, 
          });
        }

        // Handle Bundle Products
        if(this.compProductsAtcBtn){
          this.compBundlerProductsId = this.compProductsAtcBtn.dataset.complimentaryProducts;
          this.mainProductId = this.compProductsAtcBtn.dataset.mainProductId;
          this.mainProductQty = this.compProductsAtcBtn.dataset.mainProductQty;
          
          // Check for existing bundle products
          if(this.installationProductId){
            const hasExisting = await this.checkAndUpdateExistingBundleProduct(this.mainProductId, +this.mainProductQty, true);
            if(hasExisting) return;
          } else {
            const hasExisting = await this.checkAndUpdateExistingBundleProduct(this.mainProductId, +this.mainProductQty, false);
            if(hasExisting) return;
          }
          
          // IMPORTANT: Only add main product if qty-1 is greater than 0
          if(+this.mainProductQty - 1 > 0){
            items = [
              { 
                id: this.mainProductId, 
                quantity: +this.mainProductQty - 1,
                properties: this.installationProductId ? {
                  _installation_parent: 'true'
                } : {}
              },
            ];
          } else {
            items = [];
          }
          
          // Add complementary products
          if(this.compBundlerProductsId){
            const compIds = this.compBundlerProductsId.split(',').filter(Boolean);
            const compItems = compIds.map(productId => ({
              id: productId,
              quantity: 1,
            }));
            items = [...items, ...compItems];  
          }

          // Add installation to bundle
          if(this.installationProductId){
            items.push({ 
              id: this.installationProductId,
              quantity: +this.mainProductQty,
              properties: {
                _installation_for: this.mainProductId,
                _is_installation: 'true'
              }, 
            });
          }
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Rebuild formData for submission
        const finalFormData = new FormData(this.form);
        
        if (this.cart) {
          finalFormData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          finalFormData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Add installation parent property to main product
        if(this.installationProductId && !isBundlerButton){
          finalFormData.append('properties[_installation_parent]', 'true');
        }

        if(this.installationProductId && isBundlerButton){
          finalFormData.append('properties[_installation_parent]', 'true');
        }

        let isFreebieProductAvail = true;
        const cartItems = document.querySelectorAll(".cart-item");
        cartItems.forEach(cartItem => {
          const cartItemId = cartItem.dataset.productId;
          if(cartItemId == this.freebieProductId){
            isFreebieProductAvail = false;
          }
        });
        
        if(this.freebieProductId && isFreebieProductAvail){
          items.forEach((item, index) => {
            finalFormData.append(`items[${index}][id]`, item.id);
            finalFormData.append(`items[${index}][quantity]`, item.quantity);
          });
        }

        if(this.stairsProductId){
          items.forEach((item, index) => {
            finalFormData.append(`items[${index}][id]`, item.id);
            finalFormData.append(`items[${index}][quantity]`, item.quantity);
            if (item.properties) {
              for (const [key, value] of Object.entries(item.properties)) {
                finalFormData.append(`items[${index}][properties][${key}]`, value);
              }
            }
          });
        }

        // Add installation product to form data (non-bundle)
        if(this.installationProductId && !isBundlerButton){
          let itemIndex = 0;
          finalFormData.append(`items[${itemIndex}][id]`, this.installationProductId);
          finalFormData.append(`items[${itemIndex}][quantity]`, mainQuantity);
          finalFormData.append(`items[${itemIndex}][properties][_installation_for]`, mainProductId);
          finalFormData.append(`items[${itemIndex}][properties][_is_installation]`, 'true');
        }

        // Add bundle items (including installation)
        if(isBundlerButton){
          items.forEach((item, index) => {
            finalFormData.append(`items[${index}][id]`, item.id);
            finalFormData.append(`items[${index}][quantity]`, item.quantity);
            if (item.properties) {
              for (const [key, value] of Object.entries(item.properties)) {
                finalFormData.append(`items[${index}][properties][${key}]`, value);
              }
            }
          });
        }

        if(this.submitButton.classList.contains("sticky-atc")){
          const mainProdVariantQty = +this.submitButton.getAttribute("data-sticky-atc-qty");
          finalFormData.set("quantity", mainProdVariantQty);
          
          if(this.installationProductId){
            finalFormData.append('properties[_installation_parent]', 'true');
            let itemIndex = 0;
            finalFormData.append(`items[${itemIndex}][id]`, this.installationProductId);
            finalFormData.append(`items[${itemIndex}][quantity]`, mainProdVariantQty);
            finalFormData.append(`items[${itemIndex}][properties][_installation_for]`, mainProductId);
            finalFormData.append(`items[${itemIndex}][properties][_is_installation]`, 'true');
          }
        }

        this.productSellingPlanId = this.submitButton.dataset.sellingPlanId;
        if(this.productSellingPlanId){
          finalFormData.append("selling_plan", this.productSellingPlanId);
          finalFormData.append('properties[_isBundled]',true);
          finalFormData.append('properties[_isRental]',true);
        }
        
        config.body = finalFormData;

        const widgetButton = document.querySelector(".quick-add__submit.button.widget-atc-button");
        if (widgetButton) {
          widgetButton.disabled = true;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: finalFormData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: finalFormData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            document.querySelectorAll("quantity-input input[name='quantity']").forEach((input) => {
              input.value = 1;
              input.dispatchEvent(new Event("change", { bubbles: true }));
            });
          });
      }

      async checkAndUpdateExistingProduct(variantId, quantityToAdd) {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          
          const existingItem = cart.items.find(item => 
            item.variant_id == variantId && 
            (!item.properties || !item.properties._installation_parent)
          );

          if (existingItem) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({id: existingItem.key, quantity: 0})
            });

            const newQuantity = existingItem.quantity + quantityToAdd;
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({
                items: [
                  {id: variantId, quantity: newQuantity, properties: {_installation_parent: 'true'}},
                  {id: this.installationProductId, quantity: newQuantity, properties: {_installation_for: variantId, _is_installation: 'true'}}
                ]
              })
            });

            if (addResponse.ok) {
              const result = await addResponse.json();
              const sections = this.cart.getSectionsToRender();
              const sectionsData = {};
              
              for (const section of sections) {
                const sectionResponse = await fetch(`${routes.cart_url}?section_id=${section.section || section.id}`);
                sectionsData[section.section || section.id] = await sectionResponse.text();
              }
              
              result.sections = sectionsData;
              if (this.cart) this.cart.renderContents(result);
              
              publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variantId, cartData: result});
            }

            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return true;
          }
          return false;
        } catch (error) {
          console.error('Error:', error);
          return false;
        }
      }

      async checkAndUpdateExistingBundleProduct(variantId, quantityToAdd, hasInstallation = true) {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const existingItem = cart.items.find(item => item.variant_id == variantId);

          if (existingItem) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            this.querySelector('.loading__spinner').classList.remove('hidden');

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({id: existingItem.key, quantity: 0})
            });

            const oldInstallation = cart.items.find(item => 
              item.properties && item.properties._is_installation === 'true' && item.properties._installation_for == variantId
            );

            if (oldInstallation) {
              await fetch('/cart/change.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({id: oldInstallation.key, quantity: 0})
              });
            }

            const newQuantity = existingItem.quantity + quantityToAdd;
            const itemsToAdd = [{
              id: variantId,
              quantity: newQuantity,
              properties: hasInstallation ? {_installation_parent: 'true'} : {}
            }];

            if(hasInstallation && this.installationProductId){
              itemsToAdd.push({
                id: this.installationProductId,
                quantity: newQuantity,
                properties: {_installation_for: variantId, _is_installation: 'true'}
              });
            }

            if(this.compBundlerProductsId){
              const compIds = this.compBundlerProductsId.split(',').filter(Boolean);
              compIds.forEach(productId => {
                itemsToAdd.push({id: productId, quantity: 1});
              });
            }
            
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({items: itemsToAdd})
            });

            if (addResponse.ok) {
              const result = await addResponse.json();
              const sections = this.cart.getSectionsToRender();
              const sectionsData = {};
              
              for (const section of sections) {
                const sectionResponse = await fetch(`${routes.cart_url}?section_id=${section.section || section.id}`);
                sectionsData[section.section || section.id] = await sectionResponse.text();
              }
              
              result.sections = sectionsData;
              if (this.cart) this.cart.renderContents(result);
              
              publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variantId, cartData: result});
            }

            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return true;
          }
          return false;
        } catch (error) {
          console.error('Error:', error);
          return false;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if(this.errorMessage.classList.contains("main-product-message")){
            this.errorMessage.textContent = `For the main product ${errorMessage}`;
          }else{
            this.errorMessage.textContent = errorMessage;
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}